/** Brand mark: a geofence — two concentric rings with a presence dot slightly off-centre. */
export function LogoMark({ size = 28, className = '' }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" className={className}>
      <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.25" opacity="0.35" />
      <circle cx="16" cy="16" r="8.5" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="18.5" cy="13.5" r="3" fill="currentColor" />
    </svg>
  )
}

export function Wordmark({ className = '', tone = 'dark' }: { className?: string; tone?: 'dark' | 'light' }) {
  const tile = tone === 'dark' ? 'bg-ink-900 text-paper shadow-ink' : 'bg-paper text-ink-900'
  const text = tone === 'dark' ? 'text-ink-900' : 'text-paper'
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span className={`grid size-8 place-items-center rounded-[10px] ${tile}`}>
        <LogoMark size={20} />
      </span>
      <span className={`text-[15px] font-semibold tracking-[-0.01em] ${text}`}>CrewPresence</span>
    </span>
  )
}
